import { Button, Modal, ModalProps, Spin, Tabs, message } from 'antd';
import copy from 'copy-to-clipboard';
import React from 'react';

import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

import * as CONSTANT from './constant';
import getActualShareLink from './getActualShareLink';

const { TabPane } = Tabs;

interface ISharingModal {
  id: number;
  fetching?: boolean;
  modalProps: ModalProps;
}

const SharingModal: React.FC<ISharingModal> = ({ id, fetching, modalProps }) => {
  const { userInfo } = useInitialInfoStore();

  const url = id > 0 ? `${window.location.pathname}?share_id=${id}` : window.location.pathname;

  const finalUrl = getActualShareLink(url, userInfo.customer_id);

  const handleOnCopy = React.useCallback(() => {
    copy(finalUrl);
    message.success(CONSTANT.SUCCESS_CLIPBOARD, 3);
  }, [finalUrl]);

  return (
    <Modal title="Share Paths" footer={null} maskClosable={false} {...modalProps}>
      <div>
        <Tabs defaultActiveKey="link">
          <TabPane tab={CONSTANT.TAB_LINK} key="link">
            <Spin spinning={fetching}>
              {fetching ? (
                <div />
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  <div>
                    <a target="_blank" rel="noopener noreferrer" href={finalUrl}>
                      {finalUrl}
                    </a>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <Button type="primary" onClick={handleOnCopy}>
                      {CONSTANT.CLIPBOARD}
                    </Button>
                  </div>
                </div>
              )}
            </Spin>
          </TabPane>
        </Tabs>
      </div>
    </Modal>
  );
};

export default SharingModal;
